"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
exports.RECAPTCHA_SETTINGS = new core_1.InjectionToken('recaptcha-settings');



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2032928750/src/~/ng-recaptcha/recaptcha/recaptcha-settings.js
// module id = LrTf
// module chunks = 6